import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from './app.material.module';
import { SharedRoutingModule } from './shared-routing.module';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { RouterModule, Routes } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule } from '@angular/forms';
import { SearchClaimsComponent } from './components/search-claims/search-claims.component';
import { DocumentUploadComponent } from './components/document-upload/document-upload.component';
import { DocumentUploadDirective } from './components/document-upload/directives/document-upload.directive';
import { EmailSupportComponent } from './components/email-support/email-support.component';
import { DoctorListComponent } from './components/doctor-list/doctor-list.component';
import { DoctorsListDialogComponent } from './components/doctor-list/components/doctors-list-dialog.component';
import { DocumentViewerComponent } from './components/document-viewer/document-viewer.component';
import { MailListComponent } from './components/mail-box/components/mail-list/mail-list.component';
import { MailDetailsComponent } from './components/mail-box/components/mail-details/mail-details.component';
import { MailConfigurationComponent } from './components/mail-box/components/mail-configuration/mail-configuration.component';
import { MailBoxComponent } from './components/mail-box/mail-box.component';
import { SharedService } from 'src/app/core/services/shared.service';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { QRCodeModule } from 'angularx-qrcode';
import { MailConfirmationComponent } from './components/mail-box/components/mail-confirmation/mail-confirmation.component';
import { FinnovaPaymentsComponent } from './components/finnova-payments/finnova-payments.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@NgModule({
  declarations: [HeaderComponent, FooterComponent, SearchClaimsComponent, DocumentUploadComponent, DocumentUploadDirective, DocumentViewerComponent, EmailSupportComponent, DoctorListComponent, DoctorsListDialogComponent, MailListComponent, MailDetailsComponent, MailConfigurationComponent, MailConfirmationComponent, MailBoxComponent,FinnovaPaymentsComponent],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    SharedRoutingModule,
    FlexLayoutModule,
    NgxExtendedPdfViewerModule,
    QRCodeModule,
    MatFormFieldModule,
    MatInputModule

  ],
  exports: [
    HeaderComponent,
    MaterialModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    NgxExtendedPdfViewerModule,
    QRCodeModule,
    MailListComponent,
    MailDetailsComponent,
    MailBoxComponent
    ,
    FinnovaPaymentsComponent
  ],
  providers: [SharedService],
  entryComponents: [MailConfigurationComponent, MailConfirmationComponent, SearchClaimsComponent]
})
export class SharedModule { }
